import { FormEvent, useContext, useState } from "react";

import { SearchWorkflowTemplateTasksResponseTask } from "../../../../models";
import { WorkflowTemplateContext } from "../../../../route/shared/workflows";
import { ServiceError, Status } from "../../../../service/Shared";
import { getErrorMessageFromCode } from "../../../../service/ValidationErrorFormatter";
import { deleteWorkflowTemplateTask } from "../../../../service/workflow/WorkflowService";
import { useIsLoadingWrapper } from "../../../../utils";
import { Toast } from "../../../../widget";

interface UseDeleteTemplateTaskModalProps {
  closeModal: () => void;
  closePanel: () => void;
  templateTask?: SearchWorkflowTemplateTasksResponseTask;
}

interface UseDeleteTemplateTaskModalReturnData {
  handleDeleteTemplateTask: (e: FormEvent<HTMLFormElement>) => void;
  isHandleDeleteTemplateTaskLoading: boolean;
  onCancel: () => void;
  errors: ServiceError[];
}

export const useDeleteTemplateTaskModal = ({
  closeModal,
  closePanel,
  templateTask,
}: UseDeleteTemplateTaskModalProps): UseDeleteTemplateTaskModalReturnData => {
  const { shouldRefreshWorkflowTemplate } = useContext(WorkflowTemplateContext);
  const [errors, setErrors] = useState<ServiceError[]>([]);
  const [isHandleDeleteTemplateTaskLoading, setIsHandleDeleteTemplateTaskLoading] = useState(false);
  const onCancel = (): void => {
    setErrors([]);
    closeModal();
  };

  const handleDeleteTemplateTask = useIsLoadingWrapper(async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setErrors([]);

    if (!templateTask) {
      setErrors([
        {
          code: "NO_TASK",
          message: "A task must be selected",
        },
      ]);
    } else {
      await deleteWorkflowTemplateTask({
        workflowTemplateTaskRowVersion: templateTask.rowVersion,
        workflowTemplateTaskUuid: templateTask.uuid,
      }).then((response) => {
        if (response.status === Status.Success) {
          Toast.success({ message: "Template task successfully deleted" });

          shouldRefreshWorkflowTemplate();
          closePanel();
        }
        if (response.status === Status.Error && response.errors) {
          setErrors(response.errors.map((error) => ({ ...error, message: getErrorMessageFromCode(error.code) })));
        }
      });
    }
  }, setIsHandleDeleteTemplateTaskLoading);

  return {
    handleDeleteTemplateTask,
    isHandleDeleteTemplateTaskLoading,
    onCancel,
    errors,
  };
};
